import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import SyncAltIcon from '@material-ui/icons/SyncAlt'
import { makeStyles } from '@material-ui/core/styles'
import {
  SCHEDULE_AVAILABILITY_BLOCKED_FILL,
  SCHEDULE_AVAILABILITY_BLOCKED_STRIPE,
  SCHEDULE_AVAILABILITY_OUTSIDE_HOURS,
} from 'pages/pga-coach/bookings/schedule/calendar/schedule-availability-styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderTop: '1px solid #E0E0E0',
    backgroundColor: '#FAFBFC',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  swatch: {
    width: 14,
    height: 14,
    borderRadius: 2,
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  outsideHours: {
    backgroundColor: SCHEDULE_AVAILABILITY_OUTSIDE_HOURS,
    border: '1px solid #D0D0D0',
  },
  bookable: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #D0D0D0',
  },
  blocked: {
    backgroundColor: SCHEDULE_AVAILABILITY_BLOCKED_FILL,
    backgroundImage: SCHEDULE_AVAILABILITY_BLOCKED_STRIPE,
    border: '1px solid rgba(176, 184, 193, 0.45)',
  },
  syncedIcon: {
    fontSize: 14,
    color: '#4F5B62',
  },
}))

const LegendItem = ({ classes, swatchClass, label, icon }) => (
  <Box className={classes.item}>
    <span className={`${classes.swatch} ${swatchClass}`} aria-hidden />
    <Typography variant="body2" color="textSecondary">
      {label}
    </Typography>
    {icon}
  </Box>
)

const Legend = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <LegendItem
        classes={classes}
        swatchClass={classes.outsideHours}
        label="Outside bookable hours"
      />
      <LegendItem
        classes={classes}
        swatchClass={classes.bookable}
        label="Bookable hours"
      />
      <LegendItem
        classes={classes}
        swatchClass={classes.blocked}
        label="Blocked"
      />
      <LegendItem
        classes={classes}
        swatchClass={classes.blocked}
        label="Imported · not editable"
        icon={<SyncAltIcon className={classes.syncedIcon} />}
      />
    </Box>
  )
}

export default Legend
